import React, { useState } from 'react';
import cn from 'classnames';
import styles from './Nav.module.scss';
import Image from '../../Image';
import logo from '../../../assets/logo.jpg';
import menu from '../../../assets/nav/menu.png';

export default function RailsMobileSchoolNav({ currentUser, schoolTypeName }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isYearbooksOpen, setIsYearbooksOpen] = useState(false);
  const [isClassPicturesOpen, setIsClassPicturesOpen] = useState(false);
  const [isGradePagesOpen, setIsGradePagesOpen] = useState(false);

  return (
    <nav
      className={cn({
        [styles.navContainer]: true,
        noPrint: true,
        'rails-nav': true,
      })}
      style={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <div className={cn(styles.cartLink, styles.dropdown)} style={{ marginLeft: '1em' }}>
        <button
          className={styles.button}
          style={{ padding: '.5em' }}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          type="button"
        >
          <Image alt="Menu" src={menu} />
        </button>
        <ul
          className={cn({
            [styles.dropdownMenu]: true,
            [styles.hidden]: !isMenuOpen,
          })}
        >
          <li>
            <a href="/pages/home">Home Page</a>
          </li>
          <li>
            <a href="/contracts" rel="noopener noreferrer" target="_blank">Contract</a>
          </li>
          <li>
            <a href={`/schools/schooledit?id=${currentUser.school_id}`} target="_blank">School Data/Jobs</a>
          </li>
          <li>
            <a href="/school_files" target="_blank" rel="noreferrer">Files</a>
          </li>
          {schoolTypeName === 'High School' && (
            <li>
              <a href="https://admin.shoobphoto.com/senior-status" rel="noopener noreferrer" target="_blank">
                Senior Portraits
              </a>
            </li>
          )}
          <li>
            <a href="/export/students">Students</a>
          </li>
          {schoolTypeName !== 'High School' && schoolTypeName !== 'Middle School' && (
            <li className={styles.dropdown}>
              <button
                className={styles.button}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsClassPicturesOpen(!isClassPicturesOpen);
                }}
                type="button"
              >
                Class Pictures
              </button>
              <ul
                className={cn({
                  [styles.dropdownMenu]: true,
                  [styles.hidden]: !isClassPicturesOpen,
                })}
                style={{ position: 'relative', top: 0, left: '1em' }}
              >
                <li>
                  <a href={`/schools/${currentUser.school_id}/class_pictures`}>Correct Class Pictures</a>
                </li>
                <li>
                  <a href={`/schools/${currentUser.school_id}/correction_status`}>View Correction Status</a>
                </li>
              </ul>
            </li>
          )}
          <li>
            <a href="/awards">Awards</a>
          </li>
          <li className={styles.dropdown}>
            <button
              className={styles.button}
              onClick={(e) => {
                e.stopPropagation();
                setIsYearbooksOpen(!isYearbooksOpen);
              }}
              type="button"
            >
              Yearbooks
            </button>
            <ul
              className={cn({
                [styles.dropdownMenu]: true,
                [styles.hidden]: !isYearbooksOpen,
              })}
              style={{ position: 'relative', top: 0, left: '1em' }}
            >
              <li>
                <a href="/yearbook_requests/new">Sign Up</a>
              </li>
              <li>
                <a href="/order_packages">Sales</a>
              </li>
              <li>
                <a href="/order_packages/choose_yearbook_sales_or_submit">Class Pages by Teacher</a>
              </li>
              <li className={styles.dropdown}>
                <button
                  className={styles.button}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsGradePagesOpen(!isGradePagesOpen);
                  }}
                  type="button"
                >
                  Class Pages by Grade
                </button>
                <ul
                  className={cn({
                    [styles.dropdownMenu]: true,
                    [styles.hidden]: !isGradePagesOpen,
                  })}
                  style={{ position: 'relative', top: 0, left: '1em' }}
                >
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=7`}>Default</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=5`}>5 photos per row</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=6`}>6 photos per row</a></li>
                  <li><a href={`/schools/${currentUser.school_id}/download_all_grade_yb_pages?photos_per_row=7`}>7 photos per row</a></li>
                </ul>
              </li>
              <li>
                <a href="/yearbooks/templates">Canva Cover Templates</a>
              </li>
              <li>
                <a href="/yearbook_submissions/new?cover_only=yes">Submit Cover</a>
              </li>
              <li>
                <a href="/yearbook_submissions/new?cover_only=no">Submit Yearbook</a>
              </li>
              <li>
                <a href="/yearbooks/faq">FAQ</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="/school_resources">Resources for Schools</a>
          </li>
          <li>
            <a rel="nofollow" data-method="delete" href="/users/sign_out">Logout</a>
          </li>
        </ul>
      </div>
      <a href="/" style={{ paddingRight: '1em' }}>
        <Image src={logo} classes={styles.logo} />
      </a>
    </nav>
  );
}
